module.exports = __webpack_public_path__ + "assets/img/922200.5d4d44f1.jpg";